var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { conversationsApi } from 'apis/conversations';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { Sentry, SentryTeam } from 'app/utils/sentry';
import { useNotifications } from 'hooks/useNotifications';
import { isResponseWithData } from 'utils/apis/axios';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/** Represents the component for closing the conversation. */
export const ConversationsTableRowMenuClose = ({ conversation, toggleDropdown, }) => {
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const { id: csid, live_assesment } = conversation;
    const isEndUserConnected = !!(live_assesment === null || live_assesment === void 0 ? void 0 : live_assesment.is_end_user_connected);
    const label = isEndUserConnected ? 'End conversation' : 'Close conversation';
    /** Handles closing the conversation. */
    const handleClick = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        toggleDropdown();
        const { isCancelled, isConfirmed, confirm } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:confirm',
                arg: {
                    title: isEndUserConnected
                        ? 'Are you sure you want end a live conversation?'
                        : 'Are you sure you want to close a conversation?',
                    description: isEndUserConnected
                        ? 'This action will end a live conversation with a customer.'
                        : `This action will close conversation #${csid}.`,
                    confirm: {
                        variant: 'danger',
                        label: `Yes, ${isEndUserConnected ? 'end' : 'close'} conversation`,
                        async: true,
                        asyncLabel: `${isEndUserConnected ? 'Ending' : 'Closing'} conversation...`,
                    },
                },
            },
        }));
        if (isCancelled) {
            analytics.modalConversationCloseCancelClicked();
        }
        if (isConfirmed) {
            analytics.modalConversationCloseConfirmClicked({ csid });
            confirm(() => __awaiter(void 0, void 0, void 0, function* () {
                const response = yield dispatch(conversationsApi.endpoints.updateConversationClose.initiate({ csid }));
                if (isResponseWithData(response)) {
                    analytics.conversationClosed({
                        location: 'conversationsOverview',
                        channel: conversation.initial_channel,
                        language: 'language' in conversation.attributes
                            ? conversation.attributes.language
                            : undefined,
                        direction: conversation.direction,
                    });
                    notify({
                        title: `Conversation ${isEndUserConnected ? 'ended' : 'closed'}`,
                        text: `Conversation #${csid} was successfully ${isEndUserConnected ? 'ended' : 'closed'}`,
                        icon: 'info',
                        status: 'success',
                        time: 3000,
                    });
                }
                else {
                    Sentry.captureException(response.error, {
                        tags: {
                            team: SentryTeam.Conversations,
                        },
                    });
                    notify({
                        title: `Error while ${isEndUserConnected ? 'ending' : 'closing'} conversation`,
                        text: `${isEndUserConnected ? 'Ending' : 'Closing'} conversation ${csid} was not successful.`,
                        icon: 'exclamation',
                        status: 'warning',
                    });
                }
            }));
        }
    }), [
        isEndUserConnected,
        csid,
        conversation.initial_channel,
        conversation.attributes,
        conversation.direction,
        dispatch,
        toggleDropdown,
        notify,
    ]);
    return _jsx(ButtonList.Item, Object.assign({ onClick: handleClick }, { children: label }));
};
